import axios from 'axios';

const { REACT_APP_STOCK_DOMAIN } = process.env;

const SingleKeywordsAPI = keyword => {
	const formData = new FormData();
	formData.append('data', keyword); // 這裡是關鍵！後端要求欄位名為 data

	return axios.post(
		`${REACT_APP_STOCK_DOMAIN}/data_fetch/api/company_keywords`,
		formData,
		{
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export default { SingleKeywordsAPI };
